import { render, staticRenderFns } from "./PersonAnalyze.vue?vue&type=template&id=09e992c9&lang=pug&"
import script from "./PersonAnalyze.vue?vue&type=script&lang=js&"
export * from "./PersonAnalyze.vue?vue&type=script&lang=js&"
import style0 from "./PersonAnalyze.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports